import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioGuia } from "app/features/componentes/folioguia";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

export interface Props {
    value: models.FiltroGuiasSucursalZE;
    onChange: (value: models.FiltroGuiasSucursalZE) => void;
    verClienteOrigen?: boolean;
    Session: models.Session;
}

const importeMayorCero = SelectorSimpleFactory([
    { label: "Cero", value: false },
    { label: "Mayor a cero", value: true }
], x => x.value, x => x.label);

const LimiteGuias = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

/**
* Componente para editar un FiltroGuia
*/
export class FiltroGuiaComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroGuiasSucursalZE> {
        return {};
    }


    /**
     Establece la hora desde a la primer hora del día 12:00 am
     */
    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuiasSucursalZE> = { FechaInicio: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuiasSucursalZE> = { FechaInicio: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuiasSucursalZE> = { FechaFinal: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuiasSucursalZE> = { FechaFinal: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    private verClienteOrigen = (props: Props) => props.verClienteOrigen;


    render() {
        const { value } = this.props;
        const verClienteOrigen = this.verClienteOrigen(this.props);
        
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Folio = getField(FolioGuia);
        const StatusFacturacion = getField(selectores.StatusFacturacion);
        const StatusGuia = getField(selectores.StatusGuia);
        const SiNo = getField(selectores.SiNo);
        const Importe = getField(importeMayorCero);
        const Acuse = getField(selectores.TipoAcuse);
        const Limite = getField(LimiteGuias);
        return (
            <div>
                {kea.autogrid(6, [
                    this.props.Session.Permisos.ZonaExtendida.VerSelectorSucursalZonaExtendida && <Sucursal field="IdSucursalZE" label="Sucursal de zona extendida" />
                ])}                
                {kea.autogrid(2, [
                    <Sucursal field="IdSucursalStatus" label="Sucursal actual" />,
                    <Sucursal field="IdSucursalOrigen" label="Sucursal origen" />,
                    <Sucursal field="IdSucursalDestino" label="Sucursal destino" />,
                    <Datetime field="FechaInicio" label="Fecha de creación (inicio)" onChange={this.onFechaDesdeChange} />,
                    <Datetime field="FechaFinal" label="Fecha de creación (final)" onChange={this.onFechaHastaChange} />,
                    <Cliente field="IdClienteDestino" label="Cliente destino" />,
                    verClienteOrigen ? <Cliente field="IdClienteOrigen" label="Cliente origen" /> : null,
                    <Folio field="Folio" />,
                    <StatusFacturacion field="StatusGuiaFacturacion" label="Status guía facturación" />,
                    <StatusGuia field="Status" label="Status" />,
                    <SiNo field="FletePorCobrar" label="FXC" />,
                    <SiNo field="EntregaDomicilio" label="EAD" />,
                    <SiNo field="RecoleccionDomicilio" label="RAD" />,
                    <Acuse field="TipoAcuse" label="Acuse" />,
                    <Importe field="ImporteMayorCero" label="Importe total" />,
                    <Limite field="Limite" label="Limite" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaguiasentregarze/list/filtro.tsx